export function validateEmail(email) {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regex.test(email);
}



// WEBPACK FOOTER //
// ./src/utils/emailValidation.js